import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';
import './App.css';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRoute from './Components/AppRoute';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import { Provider } from 'react-redux';
import store from './Store/store';

function Layout() {
  const location = useLocation();
  const hideLayout = location.pathname === "/access-denied" || location.pathname === "/portals-login";

  return (
    <>
      {!hideLayout && <Header />}
      <AppRoute />
      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
